import { gql, useQuery } from "@apollo/client";

import { useCurrentAccountId } from "@zapier/identity";

import { HeldRunAppQuery } from "./useHeldApp.generated";

type Input = {
  skip: boolean;
  taskId: string;
};

export const getHeldAppQuery = gql`
  query HeldRunApp($accountId: ID!, $taskId: ID!) {
    runHeldApp(accountId: $accountId, id: $taskId) {
      id
      name
    }
  }
`;

function useHeldApp({ skip, taskId }: Input) {
  const accountId = useCurrentAccountId();
  const { data, loading } = useQuery<HeldRunAppQuery>(getHeldAppQuery, {
    skip,
    variables: {
      accountId,
      taskId,
    },
  });

  return {
    app: data?.runHeldApp,
    isLoading: loading,
  };
}

export default useHeldApp;
